import { Hint, SummaryGrid, SummaryItem } from './styles'
import { WarningList } from './resultStyles'
import { IDR_REASONS, formatIdr, formatProtection, formatWire, incompleteReason, isIncomplete } from './format'

function collectWarnings(result) {
  const warnings = []

  result.boards.forEach((board) => {
    if (isIncomplete(board.mainProtection)) {
      warnings.push(`${board.name}: alimentação não concluída - ${incompleteReason(board.mainProtection)}`)
    }

    ;(board.idrs || []).forEach((idr) => {
      if (idr.reason) {
        warnings.push(`${board.name}, ${idr.id}: ${IDR_REASONS[idr.reason] || idr.reason}`)
      }
    })
  })

  return warnings
}

export function ResultSummary({ result }) {
  const root = result.boards.find((board) => board.id === result.rootBoardId) || result.boards[0]
  const idrs = result.boards.flatMap((board) => (board.idrs || []).map((idr) => ({ board, idr })))
  const warnings = collectWarnings(result)

  return (
    <>
      <SummaryGrid>
        <SummaryItem>
          <span>Disjuntor geral ({root.name})</span>
          <strong>{formatProtection(root.mainProtection)}</strong>
        </SummaryItem>
        <SummaryItem>
          <span>Cabo de alimentação ({root.name})</span>
          <strong>{formatWire(root.mainProtection)}</strong>
        </SummaryItem>
        <SummaryItem>
          <span>IDRs</span>
          <strong>{idrs.length}</strong>
          {idrs.map(({ board, idr }) => (
            <small key={`${board.id}-${idr.id}`}>
              {board.name} · {idr.id}: {formatIdr(idr)}
            </small>
          ))}
        </SummaryItem>
      </SummaryGrid>
      {warnings.length > 0 ? (
        <WarningList>
          {warnings.map((warning) => (
            <li key={warning}>{warning}</li>
          ))}
        </WarningList>
      ) : (
        <Hint>Nenhum aviso de dimensionamento incompleto.</Hint>
      )}
    </>
  )
}
